export enum CellType {
  Custom,
  Text,
  Badge,
  Action,
  Checkbox,
  Empty,
  CollapseControl,
}
